import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "me-2 fas fa-mobile-alt" }, null, -1 /* HOISTED */)
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available")
], -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  type: "button",
  class: "btn px-1 py-0 ms-1 btn-outline-primary icon-size",
  "data-bs-toggle": "dropdown",
  id: "ReferralRow__Actions${id}"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h icon-size" }, null, -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  class: "dropdown-menu",
  "aria-labelledby": "ReferralRow__Actions${id}"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "No Actions Available")
], -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "transfer-form-row-one"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "-", -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_32 = {
  key: 1,
  class: "align-middle"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  class: "align-middle"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_37 = {
  key: 1,
  class: "align-middle"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "big-text" }, [
    /*#__PURE__*/_createElementVNode("i", null, "Refer In Progress")
  ])
], -1 /* HOISTED */)
const _hoisted_39 = { class: "transfer-form-row-two edit-row" }
const _hoisted_40 = {
  colspan: "8",
  class: "p-3 edit au-target"
}
const _hoisted_41 = { class: "row mx-2 px-3 pt-3" }
const _hoisted_42 = { class: "form-group d-flex flex-column ps-lg-4 col-md-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "form-check-label pb-1" }, [
  /*#__PURE__*/_createTextVNode("Classify Patient as Non-Admit "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_44 = { class: "d-flex flex-row" }
const _hoisted_45 = { class: "form-check custom-radio" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "non-admit-no"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "No")
], -1 /* HOISTED */)
const _hoisted_48 = { class: "form-check custom-radio ps-4 ms-4" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "non-admit-yes"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Yes")
], -1 /* HOISTED */)
const _hoisted_51 = { class: "form-group col-lg-2 ps-lg-0 me-lg-3 col-md-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { for: "task-name" }, " Refer To: ", -1 /* HOISTED */)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Solution", -1 /* HOISTED */)
const _hoisted_55 = ["value"]
const _hoisted_56 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_57 = { class: "form-group col-lg-2 col-md-3" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { for: "task-name" }, "Branch: ", -1 /* HOISTED */)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_60 = ["disabled"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("option", { value: "null" }, "Select Branch", -1 /* HOISTED */)
const _hoisted_62 = ["label", "value"]
const _hoisted_63 = ["value"]
const _hoisted_64 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_65 = {
  key: 0,
  class: "form-group col-lg-3 col-md-3"
}
const _hoisted_66 = ["disabled"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { for: "includeCopyOfPatientChart" }, "Include Copy Of Patient Chart", -1 /* HOISTED */)
const _hoisted_68 = { class: "row mx-2 px-3 pb-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { for: "non-admit-date" }, " Non-Admit Date: ", -1 /* HOISTED */)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_71 = { class: "input-group date datepickerInput" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_74 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { for: "non-admit-reason" }, " Non-Admit Reason: ", -1 /* HOISTED */)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_77 = ["disabled"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Non-Admit Reason", -1 /* HOISTED */)
const _hoisted_79 = ["value"]
const _hoisted_80 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_81 = { class: "text-center pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormatName = _resolveComponent("FormatName")!
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (!_ctx.showTransferForm && _ctx.patient)
    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        _createElementVNode("td", null, [
          _createVNode(_component_FormatName, {
            "first-name": _ctx.patient.patientName.firstName,
            "last-name": _ctx.patient.patientName.lastName
          }, null, 8 /* PROPS */, ["first-name", "last-name"]),
          _hoisted_2,
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.isPatient ? 'Patient' : 'Referral'
          }, null, 8 /* PROPS */, ["text"]),
          _hoisted_3,
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.patientMRN
          }, null, 8 /* PROPS */, ["text"]),
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("a", {
            href: `tel:${_ctx.patient.primaryPhoneNumber}`
          }, _toDisplayString(_ctx.formatPhone(_ctx.patient.primaryPhoneNumber)), 9 /* TEXT, PROPS */, _hoisted_6)
        ]),
        (_ctx.patient.primaryAddress)
          ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.patient.primaryAddress.addressLine1), 1 /* TEXT */),
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.patient.primaryAddress.city) + ", " + _toDisplayString(_ctx.patient.primaryAddress.state) + " " + _toDisplayString(_ctx.patient.primaryAddress.zipCode), 1 /* TEXT */)
            ]))
          : (_openBlock(), _createElementBlock("td", _hoisted_9, _hoisted_11)),
        _createElementVNode("td", null, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.dateOfBirth ? _ctx.formatDateFromDate(_ctx.patient.dateOfBirth) : null
          }, null, 8 /* PROPS */, ["text"]),
          _hoisted_12,
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.gender
          }, null, 8 /* PROPS */, ["text"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.status
          }, null, 8 /* PROPS */, ["text"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.startOfCare ? _ctx.formatDateFromDate(_ctx.patient.startOfCare) : null
          }, null, 8 /* PROPS */, ["text"]),
          _hoisted_13,
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.dischargeDate ? _ctx.formatDateFromDate(_ctx.patient.dischargeDate) : null
          }, null, 8 /* PROPS */, ["text"])
        ]),
        _createElementVNode("td", null, _toDisplayString(_ctx.ApplicationNamesEnum.getDescriptionUsingValue(_ctx.patient.application)), 1 /* TEXT */),
        _createElementVNode("td", null, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.branchName
          }, null, 8 /* PROPS */, ["text"])
        ]),
        _createElementVNode("td", _hoisted_14, [
          (_ctx.referableAgencyServices.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_ctx.patient.status == null || _ctx.listOfStatuses.includes(_ctx.patient.status))
                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass(`btn table-btn btn-outline-info mr-${_ctx.showEllipsis ? '2' : '4'}`)
                    }, [
                      _createElementVNode("i", {
                        class: "fas fa-exchange-alt",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleShowTransferForm()))
                      })
                    ], 2 /* CLASS */)), [
                      [_directive_tooltip, { title: 'Refer Patient to another Provider', placement: 'bottom' }]
                    ])
                  : _createCommentVNode("v-if", true),
                (_ctx.showEllipsis)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_16, _hoisted_18))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_19, [
                  (
                            (_ctx.patient.status === 'Non-Admitted' ||
                                _ctx.patient.status === 'Discharged' ||
                                _ctx.patient.status === 'Discharge' ||
                                _ctx.patient.status === 'NonAdmit') &&
                            (_ctx.patient.application === _ctx.ApplicationEnum.AxxessHospiceFE ||
                                _ctx.patient.application === _ctx.ApplicationEnum.AxxessPalliative)
                        )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "dropdown-item",
                        href: "javascript:void(0);",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleConvertToPending(_ctx.patient)))
                      }, " Add Referral "))
                    : _createCommentVNode("v-if", true),
                  (
                            _ctx.patient.application === _ctx.ApplicationEnum.HomeCare ||
                            _ctx.patient.application === _ctx.ApplicationEnum.AgencyCore
                        )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "dropdown-item",
                        href: "javascript:void(0);",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleReadmitPatient()))
                      }, " Readmit "))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
        ])
      ]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.patient)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
              _createElementVNode("td", null, [
                _createVNode(_component_FormatName, {
                  "first-name": _ctx.patient.patientName.firstName,
                  "last-name": _ctx.patient.patientName.lastName
                }, null, 8 /* PROPS */, ["first-name", "last-name"]),
                _hoisted_24
              ]),
              (_ctx.patient.primaryAddress)
                ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                    _createTextVNode(_toDisplayString(_ctx.patient.primaryAddress.addressLine1), 1 /* TEXT */),
                    _hoisted_26,
                    _createTextVNode(" " + _toDisplayString(_ctx.patient.primaryAddress.city) + ", " + _toDisplayString(_ctx.patient.primaryAddress.state) + " " + _toDisplayString(_ctx.patient.primaryAddress.zipCode), 1 /* TEXT */)
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_27, _hoisted_29)),
              _createElementVNode("td", null, [
                (_ctx.patient.dateOfBirth || _ctx.patient.gender)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createVNode(_component_EmptyTextHandler, {
                        text: _ctx.patient.dateOfBirth ? _ctx.formatDateFromDate(_ctx.patient.dateOfBirth) : null
                      }, null, 8 /* PROPS */, ["text"]),
                      _hoisted_31,
                      _createVNode(_component_EmptyTextHandler, {
                        text: _ctx.patient.gender
                      }, null, 8 /* PROPS */, ["text"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_32, "-"))
              ]),
              _createElementVNode("td", null, [
                (_ctx.patient.status)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createVNode(_component_EmptyTextHandler, {
                        text: _ctx.patient.status
                      }, null, 8 /* PROPS */, ["text"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_34, "-"))
              ]),
              _createElementVNode("td", null, [
                (_ctx.patient.startOfCare || _ctx.patient.dischargeDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createVNode(_component_EmptyTextHandler, {
                        text: _ctx.patient.startOfCare ? _ctx.formatDateFromDate(_ctx.patient.startOfCare) : null
                      }, null, 8 /* PROPS */, ["text"]),
                      _hoisted_36,
                      _createVNode(_component_EmptyTextHandler, {
                        text: _ctx.patient.dischargeDate ? _ctx.formatDateFromDate(_ctx.patient.dischargeDate) : null
                      }, null, 8 /* PROPS */, ["text"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_37, "-"))
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.ApplicationNamesEnum.getDescriptionUsingValue(_ctx.patient.application)), 1 /* TEXT */),
              _createElementVNode("td", null, [
                _createVNode(_component_EmptyTextHandler, {
                  text: _ctx.patient.branchName
                }, null, 8 /* PROPS */, ["text"])
              ]),
              _hoisted_38
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("tr", _hoisted_39, [
          _createElementVNode("td", _hoisted_40, [
            _createVNode(_component_FormSection, null, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "non-admit-no",
                          name: "non-admit",
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isNonAdmit) = $event)),
                          value: false,
                          disabled: _ctx.isNonAdmitDisabled()
                        }, null, 8 /* PROPS */, _hoisted_46), [
                          [_vModelRadio, _ctx.isNonAdmit]
                        ]),
                        _hoisted_47
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "non-admit-yes",
                          name: "non-admit",
                          class: "form-check-input",
                          value: true,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isNonAdmit) = $event)),
                          disabled: _ctx.isNonAdmitDisabled()
                        }, null, 8 /* PROPS */, _hoisted_49), [
                          [_vModelRadio, _ctx.isNonAdmit]
                        ]),
                        _hoisted_50
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _hoisted_53,
                    _withDirectives(_createElementVNode("select", {
                      id: "task-name",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referTo) = $event)),
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateBranches(_ctx.referTo.id))),
                      onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.referTo.$touch && _ctx.v$.referTo.$touch(...args)))
                    }, [
                      _hoisted_54,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referableAgencyServices, (agency, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: agency
                        }, [
                          _withDirectives(_createElementVNode("div", null, _toDisplayString(agency.name), 513 /* TEXT, NEED_PATCH */), [
                            [_vShow, agency.show]
                          ])
                        ], 8 /* PROPS */, _hoisted_55))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                      [_vModelSelect, _ctx.referTo]
                    ]),
                    (_ctx.v$.referTo.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_56, "Field is required."))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _hoisted_59,
                    _withDirectives(_createElementVNode("select", {
                      id: "task-name",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedBranch) = $event)),
                      disabled: !_ctx.referTo,
                      onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.selectedBranch.$touch && _ctx.v$.selectedBranch.$touch(...args)))
                    }, [
                      _hoisted_61,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providerList, (provider) => {
                        return (_openBlock(), _createElementBlock("optgroup", {
                          label: provider.name,
                          value: provider,
                          key: provider.name
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provider.branches, (branch) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: branch.name,
                              value: branch
                            }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_63))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_62))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_60), [
                      [_vModelSelect, _ctx.selectedBranch]
                    ]),
                    (_ctx.v$.selectedBranch.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Field is required."))
                      : _createCommentVNode("v-if", true)
                  ]),
                  (_ctx.patient.isPatient)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`form-group form-check mb-0 mt-4 ${_ctx.canViewDoc ? '' : 'text-muted'}`)
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.includePatientCharts) = $event)),
                            type: "checkbox",
                            class: "form-check-input",
                            id: "includeCopyOfPatientChart",
                            disabled: !_ctx.canViewDoc
                          }, null, 8 /* PROPS */, _hoisted_66), [
                            [_vModelCheckbox, _ctx.includePatientCharts]
                          ]),
                          _hoisted_67
                        ], 2 /* CLASS */),
                        _createCommentVNode(" replace above code with the commented code once permission issue is resolved "),
                        _createCommentVNode(" <span :class=\"`form-group form-check mb-0 mt-4 ${canViewDoc ? '' : 'text-muted'}`\">\r\n                                    <input\r\n                                        v-model=\"includePatientCharts\"\r\n                                        type=\"checkbox\"\r\n                                        class=\"form-check-input\"\r\n                                        id=\"includeCopyOfPatientChart\"\r\n                                        :disabled=\"!canViewDoc\"\r\n                                    />\r\n                                    <label for=\"includeCopyOfPatientChart\">Include Copy Of Patient Chart</label>\r\n                                </span> ")
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`form-group ps-lg-4 pe-lg-5 col-md-3 ${
                                    !_ctx.isNonAdmit == true ? 'd-none' : 'd-block'
                                }`)
                  }, [
                    _hoisted_69,
                    _hoisted_70,
                    _createVNode(_component_DatePicker, { getDate: _ctx.updateNonAdmitDate }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_71, [
                          _withDirectives(_createElementVNode("input", {
                            name: "nonAdmitDate",
                            type: "text",
                            class: "form-control",
                            placeholder: "MM/DD/YYYY",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.nonAdmitDate) = $event)),
                            autocomplete: "off",
                            disabled: !_ctx.isNonAdmit,
                            onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.nonAdmitDate.$touch && _ctx.v$.nonAdmitDate.$touch(...args)))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_72), [
                            [_vModelText, _ctx.nonAdmitDate]
                          ]),
                          _hoisted_73
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"]),
                    (_ctx.v$.nonAdmitDate.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_74, "Field is required."))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */),
                  _createElementVNode("div", {
                    class: _normalizeClass(`form-group col-lg-2 ps-lg-0 col-md-3 ${
                                    !_ctx.isNonAdmit == true ? 'd-none' : 'd-block'
                                }`)
                  }, [
                    _hoisted_75,
                    _hoisted_76,
                    _createCommentVNode(" <NewTypeahead\r\n                                    :disabled=\"!isNonAdmit\"\r\n                                    :data=\"nonAdmitReasons\"\r\n                                    v-model:selectedOption=\"selectedNonAdmitReason\"\r\n                                    :clearOnBlur=\"true\"\r\n                                    placeholder=\"Enter Non-Admit Reason\"\r\n                                /> "),
                    _withDirectives(_createElementVNode("select", {
                      id: "non-admit-reason",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedNonAdmitReason) = $event)),
                      disabled: !_ctx.isNonAdmit,
                      onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.v$.nonAdmitDate.$touch && _ctx.v$.nonAdmitDate.$touch(...args)))
                    }, [
                      _hoisted_78,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nonAdmitReasons, (nonAdmitReason) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: nonAdmitReason.name,
                          value: nonAdmitReason
                        }, _toDisplayString(nonAdmitReason.name), 9 /* TEXT, PROPS */, _hoisted_79))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_77), [
                      [_vModelSelect, _ctx.selectedNonAdmitReason]
                    ]),
                    (_ctx.v$.selectedNonAdmitReason.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_80, "Field is required."))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */)
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-md au-target",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.convertToRefer())),
                "au-target-id": "2039"
              }, " Refer "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary btn-md ms-2 au-target",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.closeNonAdmitForm())),
                "au-target-id": "2040"
              }, " Cancel ")
            ])
          ])
        ])
      ], 64 /* STABLE_FRAGMENT */))
}